import * as React from "react";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";

export default function CRMRelaySkeleton() {
  return (
    <div className="crm-relay-container">
      {[1, 2].map((row, rowIndex) => (
        <div key={rowIndex} className="relay-row-container">
          <div className="relay-row">
            <div className="name-section">
              <Skeleton variant="rectangular" width={24} height={80}/>
            </div>

            <div className="expand-icon">
              <Skeleton variant="rectangular" width={24} height={24} /><br/>
              <Skeleton variant="rectangular" width={24} height={60} />
            </div>

            <div className="tickets-row">
              <Skeleton
                variant="rectangular"
                width={150}
                height={70}
                sx={{ mr: 6 }}
              />

              {[1, 2].map((ticket, ticketIndex) => (
                <React.Fragment key={ticketIndex}>
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={70}
                    sx={{ mr: 6 }}
                  />
                  <Skeleton
                    variant="rectangular"
                    width={150}
                    height={70}
                    sx={{ mr: 6 }}
                  />
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      ))}

      <div className="row Line">
        <Skeleton variant="rectangular" width={150} height={70} />
      </div>
    </div>
  );
}
